import React, { useEffect, useState } from "react";

const today = new Date();
const formattedDate = today.toLocaleDateString("en-GB", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const TermsAndConditions = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-mode"));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="terms-conditions-page"
      style={{
        maxWidth: 800,
        margin: "40px auto",
        padding: 24,
        background: isDarkMode ? "#181818" : "#fff",
        color: isDarkMode ? "#f5f5f5" : "#222",
        borderRadius: 12,
        boxShadow: isDarkMode
          ? "0 2px 16px rgba(0,0,0,0.36)"
          : "0 2px 16px rgba(0,0,0,0.06)",
        transition: "background 0.3s, color 0.3s"
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: 16 }}>Terms and Conditions</h1>
      <p><strong>Effective Date:</strong> {formattedDate}<br/>
      <strong>Last Updated:</strong> {formattedDate}</p>
      
      <p>Welcome to Zip Accounts, a product developed and maintained by Nexagen Solutions. By accessing, installing, or using Zip Accounts (the "Software") via our website or through other platforms, you agree to be bound by these Terms and Conditions. If you do not agree, please refrain from using our product or services.</p>
      
      <h2>1. Introduction</h2>
      <p>These Terms and Conditions ("Terms") constitute a legal agreement between you (the "User", "Client", or "Customer") and Nexagen Solutions regarding the use of our software application, Zip Accounts, related services, website, and any associated content or documentation.</p>
      <p>We reserve the right to update or modify these Terms at any time. All changes will be effective upon posting, and your continued use signifies acceptance.</p>
      
      <h2>2. Description of Services</h2>
      <p>Zip Accounts is a business accounting and financial management software that enables users to manage ledgers, invoices, inventory, payments, vouchers, payroll, and financial reports.</p>
      <p>Features may vary based on subscription plans or deployment models (cloud-based, on-premise, etc.).</p>
      
      <h2>3. License and Usage</h2>
      <p>Upon purchase or subscription, Nexagen Solutions grants you a non-exclusive, non-transferable, revocable license to use Zip Accounts in accordance with these Terms.</p>
      <p>You may not:</p>
      <ul>
        <li>Reverse-engineer, decompile, or modify the software</li>
        <li>Share, sublicense, or resell the software without written permission</li>
        <li>Use the software for any illegal or unauthorized purpose</li>
      </ul>
      
      <h2>4. User Account Responsibilities</h2>
      <p>If using the cloud-based or web version, you are responsible for:</p>
      <ul>
        <li>Creating and maintaining secure login credentials</li>
        <li>Providing accurate business data during registration</li>
        <li>All activities conducted under your account</li>
      </ul>
      <p>You must notify us immediately if you suspect unauthorized access.</p>
      
      <h2>5. Data Ownership and Protection</h2>
      <p>All data you enter into Zip Accounts remains your property.</p>
      <p>We do not access, use, or share your data without consent, except where required by law.</p>
      <p>If hosted on our servers, we apply encryption, firewalls, backups, and secure access protocols to protect your data.</p>
      <p>If self-hosted, security becomes your responsibility.</p>
      
      <h2>6. Payment Terms</h2>
      <p>Zip Accounts may be offered as a one-time purchase or subscription-based service.</p>
      <p>All fees are non-refundable unless explicitly stated.</p>
      <p>Failure to make timely payments may result in suspension or termination of access.</p>
      
      <h2>7. Refund and Cancellation</h2>
      <p>Refunds are only applicable in case of software malfunction or failure to deliver based on the agreement.</p>
      <p>Cancellation of a subscription can be made anytime, but no partial refunds are given for the unused term.</p>
      
      <h2>8. Software Updates & Support</h2>
      <p>We provide periodic updates to enhance performance, security, and functionality.</p>
      <p>Paid support plans may include priority bug fixes, updates, feature enhancements, and user training.</p>
      <p>Nexagen is not responsible for any damage caused by delayed updates if the user fails to install or accept them.</p>
      
      <h2>9. Intellectual Property</h2>
      <p>All rights, title, and interest in Zip Accounts and its components (source code, design, UI, branding, etc.) remain the sole property of Nexagen Solutions.</p>
      <p>Unauthorized reproduction, distribution, or derivative works are strictly prohibited.</p>
      
      <h2>10. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, Nexagen Solutions is not liable for any indirect, incidental, consequential, or special damages, including loss of data or business interruption, arising from:</p>
      <ul>
        <li>Use or inability to use Zip Accounts</li>
        <li>Errors or bugs in the software</li>
        <li>Unauthorized access or breach of your data</li>
      </ul>
      
      <h2>11. Termination</h2>
      <p>We reserve the right to suspend or terminate your license if:</p>
      <ul>
        <li>You violate any of these Terms</li>
        <li>You engage in fraudulent or harmful activities</li>
        <li>Payments are overdue and unresolved</li>
      </ul>
      <p>Upon termination, you must cease all use of the software.</p>
      
      <h2>12. Privacy Policy</h2>
      <p>Your use of Zip Accounts is also governed by our Privacy Policy, which outlines how we collect, process, and secure your personal and business data.</p>
      
      <h2>13. Governing Law</h2>
      <p>These Terms are governed by the laws of the Islamic Republic of Pakistan. Any disputes will be subject to the exclusive jurisdiction of the courts in Lahore, Pakistan.</p>
      
      <h2>14. Contact Us</h2>
      <p>For any legal, technical, or general inquiries regarding Zip Accounts or these Terms:</p>
      <p><strong>Nexagen Solutions</strong><br/>
      📧 Email: <a href="mailto:info@nexagensolutions.com">info@nexagensolutions.com</a><br/>
      🌐 Website: <a href="https://www.nexagensolutions.com" target="_blank" rel="noopener noreferrer">www.nexagensolutions.com</a><br/>
      📍 Address: Ali Mall, 2nd floor, Susan road, Faisalabad, Pakistan</p>
    </div>
  );
};

export default TermsAndConditions; 